import { Badge } from 'react-bootstrap';
import { getRatingColor } from 'components/global/_helpers/global.helpers';

const RatingBadge = ({ rating }) => (
  <Badge
    bg={getRatingColor(rating)}
    className="me-16 d-inline-flex align-items-center"
  >
    {rating}
  </Badge>
);

export default RatingBadge;
